function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM7 5a1 1 0 012 0v2h2a1 1 0 110 2H9v2a1 1 0 11-2 0V9H5a1 1 0 010-2h2V5z",
  fill: "#243143"
});

function SvgAdd16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYgOEMxNiAxMi40MTgzIDEyLjQxODMgMTYgOCAxNkMzLjU4MTcyIDE2IDAgMTIuNDE4MyAwIDhDMCAzLjU4MTcyIDMuNTgxNzIgMCA4IDBDMTIuNDE4MyAwIDE2IDMuNTgxNzIgMTYgOFpNNyA1QzcgNC40NDc3MiA3LjQ0NzcyIDQgOCA0QzguNTUyMjggNCA5IDQuNDQ3NzIgOSA1VjdIMTFDMTEuNTUyMyA3IDEyIDcuNDQ3NzIgMTIgOEMxMiA4LjU1MjI4IDExLjU1MjMgOSAxMSA5SDlWMTFDOSAxMS41NTIzIDguNTUyMjggMTIgOCAxMkM3LjQ0NzcyIDEyIDcgMTEuNTUyMyA3IDExVjlINUM0LjQ0NzcyIDkgNCA4LjU1MjI4IDQgOEM0IDcuNDQ3NzEgNC40NDc3MiA3IDUgN0g3VjVaIiBmaWxsPSIjMjQzMTQzIi8+Cjwvc3ZnPgo=";
export { SvgAdd16 as ReactComponent };